<template>
  <div class="page-con">
    <div>
      <div class="page-con-header clearfix">
        <vxe-button icon="vxe-icon--refresh" @click="getListData"
          >刷新</vxe-button
        >
      </div>
      <div
        class="finance-header"
        style="display: flex; flex-wrap: wrap; padding-bottom: 10px"
      >
        <span class="finance-span finance-span-time">
          <label style="margin-right: 10px">时间</label>
          <DatePicker
            v-model="startTime"
            type="date"
            placeholder="选择日期"
            style="width: 120px"
          ></DatePicker>
          <i class="line-icon">--</i>
          <DatePicker
            v-model="endTime"
            type="date"
            placeholder="选择日期"
            style="width: 120px"
          ></DatePicker>
        </span>
        <span class="finance-span finance-client-name">
          <label>客户</label>
          <Select
            v-model="searchClientName"
            multiple
            filterable
            prefix="ios-arrow-down"
            :remote-method="
              (file) =>
                remoteMethod(
                  file,
                  'clientNameOptions',
                  'report',
                  'saleManAmountClientName'
                )
            "
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="
              (file) => setDefaultOptions(file, 'clientNameOptions')
            "
            placeholder="输入客户名称"
          >
            <Option
              v-for="option in clientNameOptions"
              :value="option.paramValue"
              :key="option.paramValue"
              >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span" style="margin-left: auto">
          <Button
            type="primary"
            icon="ios-search"
            @click="getSearchListKey"
            style="border-radius: 5px"
            >搜索</Button
          >
          <Button @click="reset" style="margin-left: 10px; border-radius: 5px"
            >重置</Button
          >
        </span>
      </div>
    </div>

    <div class="list-box common-shadow">
      <vxe-table
        ref="xTable"
        class="table-style"
        stripe
        import-config
        export-config
        highlight-hover-row
        show-overflow
        show-footer
        max-height="650"
        border="none"
        align="center"
        :loading="loading"
        :footer-cell-class-name="footerCellClassName"
        :footer-method="footerMethod"
        :data="tableData"
      >
        <vxe-table-column
          type="seq"
          title="序号"
          align="center"
          width="60"
        ></vxe-table-column>
        <vxe-table-column
          field="clientName"
          title="客户"
          min-width="120"
        ></vxe-table-column>
        <vxe-table-column
          field="salesMan"
          title="业务员"
          min-width="100"
        ></vxe-table-column>
        <vxe-table-column
          field="initAmount"
          title="期初余额"
          min-width="150"
        ></vxe-table-column>
        <vxe-table-column
          field="debitAmount"
          title="应收金额"
          min-width="150"
        ></vxe-table-column>
        <vxe-table-column
          field="creditAmount"
          title="已收金额"
          min-width="150"
        ></vxe-table-column>
        <vxe-table-column
          field="balanceAmount"
          title="余额"
          min-width="120"
        ></vxe-table-column>
        <vxe-table-column
          field="invoiceAmount"
          title="开票金额"
          min-width="150"
        ></vxe-table-column>
        <vxe-table-column
          field="orderNum"
          title="订单数"
          min-width="120"
        ></vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import moment from "moment";
import getAuthOrization from "@/mixin/getAuthOrization";
import {
  PayablesFooter,
} from "@/utils/util";
import { isEmpty } from "@/utils/util";

const empties = [undefined, "", null, "null", {}, []];

export default {
  mixins: [getAuthOrization],
  name: "PayablesList",
  data() {
    return {
      loading: false,
      searchLoading: false,
      queryAction: "",
      tableData: [],
      page: {
        currentPage: 1,
        pageSize: 10000,
        total: 0,
      },
      searchParams: {
        addTimeBegin: "",
        addTimeEnd: "",
      },
      timeVal: "",
      rangeTime: "time",
      open: false,
      startTime: "",
      endTime: "",
      searchClientName: [],
      clientNameOptions: [],
      searchFormItems: [
        {
          align: "right",
          span: 12,
          titleAlign: "left",
          itemRender: {
            name: "$buttons",
            children: [
              { props: { type: "submit", content: "搜索", status: "primary" } },
              { props: { type: "reset", content: "重置" } },
            ],
          },
        },
      ],
    };
  },
  mounted() {
    this.$bus.$on("应收账款汇总", () => {
      this.reset()
      this.startTime = moment().startOf("month").format("YYYY-MM-DD");
      this.endTime = moment().endOf("day").format("YYYY-MM-DD");
    });
    this.reset();
    this.startTime = moment().startOf("month").format("YYYY-MM-DD");
    this.endTime = moment().endOf("day").format("YYYY-MM-DD");
    this.getList("", "clientNameOptions", "report", "receivablesClientName");
  },
  methods: {
    reset() {
      this.startTime = "";
      this.endTime = "";
      this.searchClientName = [];
      this.tableData = [];
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path) {
      let params = {};

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].get(path);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    init() {
      // this.getListData()
    },
    setSearchParams(searchParams) {
      this.searchParams = searchParams;
    },
    getSearchListKey() {
      if (
        this.startTime === "" &&
        this.endTime === "" &&
        this.searchClientName.length === 0 
      ) {
        this.$XModal.alert({
          message: "请输入搜索条件",
          status: "error",
        });
        return;
      }
      let searchParams = {};
      searchParams.clientName = this.searchClientName;
      this.searchParams = searchParams;
      this.getListData();
    },
    async getListData() {
      this.tableData = [];
      this.queryAction = "receivables";
      this.loading = true;
      this.searchParams.rows = 100000;
      this.searchParams.beginDate =
        this.startTime === ""
          ? this.startTime
          : this.$utils.timestamp(this.startTime);
      this.searchParams.endDate =
        this.endTime === ""
          ? this.endTime
          : this.$utils.timestamp(this.endTime) + 86399000;
      let params = empties.includes(this.searchParams) ? {} : this.searchParams;
      // params.orderBy = 2;
      let res = await $api.report.request(this.queryAction, params);
      if (res.status === 1) {
        this.tableData = res.data.rows;
      } else {
        if (empties.includes(res.message)) res.message = "接口异常";
        this.$XModal.message(res.message);
      }
      this.loading = false;
    },
    pageChange(page) {
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.getListData();
    },
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      return "footer-cell";
    },
    footerMethod({ columns, data }) {
      return PayablesFooter({ columns, data });
    },
  },
};
</script>
<style>
.finance-client-name .ivu-select {
    width: 300px;
    height: 34px;
    overflow: hidden;
}
</style>
